export default __webpack_public_path__ + "static/media/bw-executive-function-tutorial-pop-up-icon.7ef1f336.svg";